// test1875
(1875 && 0);
